import { Stack, Box, LinearProgress, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';
import getStyles from '../../utils/getStylesForTaskStatusSelect';

export default function ProgressBar({
  value,
  maxValue = 0,
  plannedValue = 0,
  height = '8px',
  fontSize = '12px',
  status,
}) {
  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      {status ? (
        <Stack direction="column" sx={{ width: '100%' }} spacing={1}>
          <LinearProgress
            variant="determinate"
            value={Math.min((value / maxValue) * 100, 100)}
            color={(value > plannedValue && 'error') || 'success'}
            sx={{
              height,
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16),
              width: '100%', // Ensure it takes full width
            }}
          />

          <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
            <Box
              sx={{
                typography: 'subtitle1',
                fontSize,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {`${value} / ${maxValue} hrs (${Math.abs(Number(plannedValue - value)).toFixed(2)} hrs ${
                plannedValue - value > 0 ? 'left' : 'over run'
              })`}
            </Box>

            <Typography
              style={{
                ...getStyles(status),
                padding: '2px 4px',
                borderRadius: '4px',
              }}
              sx={{
                fontSize,
              }}
            >
              {status}
            </Typography>
          </Stack>
        </Stack>
      ) : (
        <Stack spacing={0.25}>
          <LinearProgress
            variant="determinate"
            value={Math.min((value / maxValue) * 100, 100)}
            color={value > plannedValue ? 'error' : 'success'}
            sx={{
              height,
              width: '100%', // Ensure it takes full width
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16),
              pt: 1,
            }}
          />

          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box sx={{ typography: 'subtitle1', fontSize }}>{`${value} / ${maxValue} hrs`}</Box>
            <Box sx={{ typography: 'subtitle1', fontSize }}>
              {`${Math.abs(Number(plannedValue - value)).toFixed(2)} hrs ${
                plannedValue - value > 0 ? 'left' : 'over run'
              }`}
            </Box>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}

// PropTypes for validation
ProgressBar.propTypes = {
  value: PropTypes.number,
  maxValue: PropTypes.number,
  plannedValue: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
